/* src/app/components/leads/upload-signatures/upload-signatures.component.css */
.signature--container {
  margin-bottom: 1rem;
}
/*# sourceMappingURL=upload-signatures.component-XWBEIZP5.css.map */
